// extracted by mini-css-extract-plugin
export var acitonButtons = "_2u-0";
export var additionalIcon = "_2u-f";
export var block = "_2u-1";
export var blockContent = "_2u-7";
export var blockDescription = "_2u-8";
export var blockIcon = "_2u-9";
export var blockTitle = "_2u-6";
export var border = "_2u-a";
export var center = "_2u-l";
export var edge = "_2u-b";
export var edgeLabel = "_2u-c";
export var edgePath = "_2u-d";
export var error = "_2u-e";
export var flowchart = "_2u-g";
export var flowchartContent = "_2u-h";
export var highlighted = "_2u-3";
export var hover = "_2u-4";
export var icon = "_2u-i";
export var left = "_2u-m";
export var navButton = "_2u-j";
export var navButtons = "_2u-k";
export var right = "_2u-n";
export var selected = "_2u-2";
export var small = "_2u-5";